import { useEffect, useContext, forwardRef } from 'react';
// mui
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

// context
import { Context } from '../../../context/Context';

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant='filled' {...props} />;
});

const Responses = () => {
  const { response, setResponse, responseInitialState, state } = useContext(Context);
  const { title, message, typeAlert, status } = response;

  const lang = state.lang;

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setResponse(responseInitialState);
  };

  const action = (
    <>
      <Button color='secondary' size='small' onClick={handleClose}>
        {lang === 'ES' ? 'Cerrar' : 'Close'}
      </Button>
      <IconButton size='small' aria-label='close' color='inherit' onClick={handleClose}>
        <CloseIcon fontSize='small' />
      </IconButton>
    </>
  );

  useEffect(() => {
    if (!status) return;
    const timeoutId = setTimeout(() => {
      setResponse(responseInitialState);
    }, 5000);
    return () => clearTimeout(timeoutId);
    // eslint-disable-next-line
  }, [status]);

  return (
    <Snackbar open={status} autoHideDuration={6000} onClose={handleClose} action={action}>
      <Alert
        onClose={handleClose}
        severity={!typeAlert || typeAlert === '' ? 'info' : typeAlert}
        sx={{ width: '100%' }}
      >
        {title + ': ' + message}
      </Alert>
    </Snackbar>
  );
};

export default Responses;
